/* unplugin-vue-components disabled */import script from "./TourCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TourCard.vue?vue&type=script&setup=true&lang=js"

import "./TourCard.vue?vue&type=style&index=0&id=e773020c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e773020c"]])

export default __exports__